import { PlacePropsList } from "../components/common/Common";

const properties: PlacePropsList = {
    0: {
        A: "장소명",
        B: "주소",
        C: "구분",
        D: "사진",
        E: "홈페이지",
    },
    1: {
        A: "카페1",
        B: "서울시 동작구 동작대로 1",
        C: "카페",
        D: "https://images.unsplash.com/photo-1726910133626-9b573eca70ff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwzfHx8ZW58MHx8fHx8",
        E: "http://30.30.30.13:3000",
    },
    2: {
        A: "카페2",
        B: "서울시 동작구 동작대로 2",
        C: "카페",
        D: "https://images.unsplash.com/photo-1726910133626-9b573eca70ff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwzfHx8ZW58MHx8fHx8",
        E: "http://30.30.30.13:3000",
    },
    3: {
        A: "카페3",
        B: "서울시 동작구 동작대로 3",
        C: "카페",
        D: "https://images.unsplash.com/photo-1726910133626-9b573eca70ff?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxmZWF0dXJlZC1waG90b3MtZmVlZHwzfHx8ZW58MHx8fHx8",
        E: "http://30.30.30.13:3000",
    },
    4: {
        A: "카페 실패",
        B: "실패",
        C: "카페",
        D: "",
        E: "",
    },
};

const coords: { [key: number]: number[] } = { 0: [0, 0], 1: [934340.1903167067, 1941710.172052234], 2: [934178.3474284753, 1941505.6879239895], 3: [934368.2947703516, 1941472.7378748886] };

const geocoding = (address: string) => {
    let _coords: number[] | undefined = undefined;

    Object.keys(properties).forEach((key) => {
        const _address = properties[Number(key)]["B"];

        if (_address === address) {
            _coords = coords[Number(key)];
        }
    });

    return _coords;
};

export { properties, geocoding };
